import { useState } from "react";
import { AssetConnectStatus } from "../models/asset";
import { fetchAssetsConnectionStatus } from "../api/fetchAssets";

function useAssetsConnectionStatus() {
    const [assetsConnectionStatus, setAssetsConnectionStatus] = useState<AssetConnectStatus[]>([]);

    const getAssetsConnectionStatus = async (assetIds: string[]) => {
        if(assetIds?.length) {
            const data = await fetchAssetsConnectionStatus(assetIds);
            setAssetsConnectionStatus([...assetsConnectionStatus, ...data]);
        }
    }

    return { assetsConnectionStatus, getAssetsConnectionStatus }
}

export default useAssetsConnectionStatus;